export default __webpack_public_path__ + "static/media/ic_link_black.290b9690.svg";